module.exports = __webpack_public_path__ + "static/img/10.99700ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/10.png
// module id = Spc1
// module chunks = 0